import { map, all, makeSemaphore, zipLeft, flatMap, succeed, as } from '../Effect/dist/effect-Effect.esm.js';
import { pipe, dual } from '../Function/dist/effect-Function.esm.js';
import { synchronizedVariance } from './effect/circular.esm.js';
import { refVariance } from './ref.esm.js';
import { pipeArguments } from '../Pipeable/dist/effect-Pipeable.esm.js';
import { unbounded, publish } from '../PubSub/dist/effect-PubSub.esm.js';
import { get as get$1, make as make$1, set as set$1, RefTypeId } from '../Ref/dist/effect-Ref.esm.js';
import { SynchronizedRefTypeId } from '../SynchronizedRef/dist/effect-SynchronizedRef.esm.js';
import { unwrapScoped, fromPubSub, concat, make as make$2 } from './stream.esm.js';

/** @internal */
const SubscriptionRefSymbolKey = "effect/SubscriptionRef";

/** @internal */
const SubscriptionRefTypeId = /*#__PURE__*/Symbol.for(SubscriptionRefSymbolKey);

/** @internal */
const subscriptionRefVariance = {
  _A: _ => _
};

/** @internal */
class SubscriptionRefImpl {
  // @ts-ignore
  [RefTypeId] = refVariance;
  // @ts-ignore
  [SynchronizedRefTypeId] = synchronizedVariance;
  [SubscriptionRefTypeId] = subscriptionRefVariance;
  constructor(ref, pubsub, semaphore) {
    this.ref = ref;
    this.pubsub = pubsub;
    this.semaphore = semaphore;
  }
  pipe() {
    return pipeArguments(this, arguments);
  }
  get changes() {
    return pipe(get$1(this.ref), flatMap(a => map(fromPubSub(this.pubsub, {
      scoped: true
    }), s => concat(make$2(a), s))), this.semaphore.withPermits(1), unwrapScoped);
  }
  modify(f) {
    return this.modifyEffect(a => succeed(f(a)));
  }
  modifyEffect(f) {
    return pipe(get$1(this.ref), flatMap(f), flatMap(([b, a]) => pipe(set$1(this.ref, a), as(b), zipLeft(publish(this.pubsub, a)))), this.semaphore.withPermits(1));
  }
}

/** @internal */
const get = self => get$1(self.ref);

/** @internal */
const make = value => pipe(all([unbounded(), make$1(value), makeSemaphore(1)]), map(([pubsub, ref, semaphore]) => new SubscriptionRefImpl(ref, pubsub, semaphore)));

/** @internal */
const modify = /*#__PURE__*/dual(2, (self, f) => self.modify(f));

/** @internal */
const modifyEffect = /*#__PURE__*/dual(2, (self, f) => self.modifyEffect(f));

/** @internal */
const set = /*#__PURE__*/dual(2, (self, value) => pipe(set$1(self.ref, value), zipLeft(publish(self.pubsub, value)), self.semaphore.withPermits(1)));

export { SubscriptionRefTypeId, get, make, modify, modifyEffect, set };
